// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * Bus de errores global para ARCHAT. Emisión centralizada y dedupe por ventana de tiempo.
 * @file frontend/src/core/errors/errorBus.js
 */

const DEDUPE_MS = 2000;
const listeners = new Set();
let lastEmit = null;
let lastPayload = null;

/**
 * @param {Object} payload
 * @param {string} payload.code - Código E-AUTH-401, E-API-404, E-NETWORK, E-UI-UNCAUGHT, etc.
 * @param {string} payload.message - Mensaje claro para el usuario
 * @param {string} [payload.requestId] - X-Request-ID o request_id
 * @param {string} [payload.path] - window.location.pathname
 * @param {string} [payload.buildId] - BUILD_ID
 * @param {string} [payload.timestamp] - ISO string
 * @param {Object} [payload.raw] - Objeto error original (sin datos sensibles)
 */
function emit(payload) {
  if (!payload) return;
  const code = payload.code != null ? String(payload.code) : 'api.error';
  if (!code) return;
  const key = `${code}|${payload.message ?? payload.message_key ?? ''}|${payload.requestId ?? ''}`;
  if (lastEmit && Date.now() - lastEmit < DEDUPE_MS && lastPayload && `${lastPayload.code}|${lastPayload.message ?? lastPayload.message_key ?? ''}|${lastPayload.requestId ?? ''}` === key) {
    return;
  }
  lastEmit = Date.now();
  lastPayload = {
    ...payload,
    code,
    timestamp: payload.timestamp || new Date().toISOString(),
  };
  listeners.forEach((cb) => {
    try {
      cb(lastPayload);
    } catch (_) {}
  });
}

/**
 * @param {(payload: Object) => void} cb
 * @returns {() => void} unsubscribe
 */
function subscribe(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

/**
 * Último payload emitido (para hidratar al montar el Provider).
 * @returns {Object|null}
 */
function getLast() {
  return lastPayload ? { ...lastPayload } : null;
}

export const errorBus = {
  emit,
  subscribe,
  getLast,
};
